var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowright(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 90.9375 75.0625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 75.0625,
    opacity: 0,
    width: 90.9375,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9375 37.5C90.9375 36.125 90.3125 34.8125 89.1875 33.75L56.9375 1.5625C55.8125 0.5 54.5625 0 53.25 0C50.5 0 48.375 2.0625 48.375 4.875C48.375 6.1875 48.8125 7.5 49.75 8.375L58.375 17.3125L79.5 36.375L80.625 33.625L64 32.4375L5 32.4375C2.0625 32.4375 0 34.5625 0 37.5C0 40.4375 2.0625 42.5625 5 42.5625L64 42.5625L80.625 41.375L79.5 38.6875L58.375 57.6875L49.75 66.625C48.8125 67.5 48.375 68.8125 48.375 70.125C48.375 72.9375 50.5 75 53.25 75C54.5625 75 55.8125 74.5 56.9375 73.4375L89.1875 41.25C90.3125 40.1875 90.9375 38.875 90.9375 37.5Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowright);
export default __webpack_public_path__ + "static/media/arrow.right.54dcbd558588232f688be91c12226e52.svg";
export { ForwardRef as ReactComponent };